export interface LanguageSelectorItem {
    itemId: string
    languageCode: string
    label: string
    selected?: boolean
}

export const LANGUAGE_DISPLAY_NAMES: Record<string, string> = {
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    fi: 'Suomi',
    fr: 'Français',
    it: 'Italiano',
    lt: 'Lietuvių',
    nl: 'Nederlands',
    pl: 'Polski',
    pt: 'Português',
    uk: 'Українська',
    ru: 'Русский',
}

export const LANGUAGE_TO_COUNTRY: Record<string, string> = {
    de: 'de',
    en: 'gb',
    es: 'es',
    fi: 'fi',
    fr: 'fr',
    it: 'it',
    lt: 'lt',
    nl: 'nl',
    pl: 'pl',
    pt: 'pt',
    uk: 'ua',
    ru: 'ru',
}

export const DEFAULT_LANGUAGE_ITEMS: LanguageSelectorItem[] = Object.entries(LANGUAGE_DISPLAY_NAMES).map(
    ([code, label]) => ({
        itemId: code,
        languageCode: code,
        label,
        selected: false,
    }),
)

export const languageCodeToItem = (code: string): LanguageSelectorItem => ({
    itemId: code,
    languageCode: code,
    label: LANGUAGE_DISPLAY_NAMES[code] || code,
    selected: false,
})
